import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useAuthStore } from '@stores/authStore';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { setUser } = useAuthStore();

  useEffect(() => {
    // Redirect to home if already logged in
    const { isAuthenticated } = useAuthStore.getState();
    if (isAuthenticated) {
      navigate('/');
    }
  }, [navigate]);

  const handleGoogleSuccess = (credentialResponse: any) => {
    try {
      // Decode the JWT token
      const decoded: any = jwtDecode(credentialResponse.credential);

      // Store user info
      setUser({
        id: decoded.sub,
        email: decoded.email,
        name: decoded.name,
        picture: decoded.picture,
      });

      // Redirect to dashboard
      navigate('/');
    } catch (error) {
      console.error('Failed to decode Google token:', error);
    }
  };

  const handleGoogleError = () => {
    console.log('Login Failed');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Control Plane</h1>
            <p className="text-gray-600 mb-6">Admin Dashboard</p>
          </div>

          <div className="flex justify-center mb-8">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap
            />
          </div>

          <div className="pt-6 border-t border-gray-200">
            <p className="text-center text-sm text-gray-600">
              Sign in with your Google account to access the dashboard.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
